import api from "../utils/api";
import i18n from "../../plugins/i18n";

const state = {
  profile: {}
};

const getters = {
  getProfile(state) {
    return state.profile;
  },
  getDateTimeFormat() {
    return state.profile.date_format;
  },
  getNumberFormatFormat() {
    return state.profile.number_format;
  }
};

const actions = {
  refreshProfile({ commit, dispatch, rootGetters }) {
    let token = rootGetters["sessionStore/getToken"];
    if (!token || token === "") return;
    return api
      .get("/me/profile")
      .then(res => {
        i18n.locale = res.data.language;
        dispatch(
          "localizationStore/localeStore/getList",
          {
            params: {
              limit: -1,
              sort: "name",
              direction: "asc",
              locale: i18n.locale
            }
          },
          { root: true }
        );
        commit("setProfile", { profile: res.data });
      })
      .catch(res =>
        dispatch(
          "notificationStore/createErrorNotificationForApiRequest",
          res,
          { root: true }
        )
      );
  },
  updateProfile(
    { commit, dispatch },
    {
      name,
      email,
      language,
      number_format,
      date_format,
      timezone,
      errorHandler = () => {}
    }
  ) {
    return api
      .put("/me/profile", {
        name,
        email,
        language,
        number_format,
        date_format,
        timezone
      })
      .then(() => {
        commit("updateProfile", {
          name,
          email,
          language,
          number_format,
          date_format,
          timezone
        });
        i18n.locale = language;
        dispatch(
          "localizationStore/localeStore/getList",
          {
            params: {
              limit: -1,
              sort: "name",
              direction: "asc",
              locale: i18n.locale
            }
          },
          { root: true }
        );
        dispatch(
          "notificationStore/createSuccessNotificationForApiRequest",
          {
            text: i18n.t("message.profile-success-update")
          },
          { root: true }
        );
        errorHandler({});
      })
      .catch(res => {
        dispatch(
          "notificationStore/createErrorNotificationForApiRequest",
          res,
          { root: true }
        );
        errorHandler(res.response.data.errors);
      });
  },
  updateEmail({ dispatch }, { password, email, errorHandler = () => {} }) {
    return api
      .put("/me/email", { password, email })
      .then(res => {
        dispatch(
          "notificationStore/createSuccessNotificationForApiRequest",
          {
            text: i18n.t(`message.${res.data.id}`)
          },
          { root: true }
        );
        errorHandler({});
      })
      .catch(res => {
        dispatch(
          "notificationStore/createErrorNotificationForApiRequest",
          res,
          { root: true }
        );
        errorHandler(res.response.data.errors);
      });
  },
  confirmEmail({ dispatch }, { code }) {
    return api
      .put(`/me/email/${code}:confirm`)
      .then(() => {
        dispatch(
          "notificationStore/createSuccessNotificationForApiRequest",
          {
            text: i18n.t("message.email-success-update")
          },
          { root: true }
        );
      })
      .catch(res =>
        dispatch(
          "notificationStore/createErrorNotificationForApiRequest",
          res,
          { root: true }
        )
      );
  },
  updatePassword(
    { dispatch },
    { password, new_password, errorHandler = () => {} }
  ) {
    return api
      .put("/me/password", { password, new_password })
      .then(res => {
        dispatch(
          "notificationStore/createSuccessNotificationForApiRequest",
          {
            text: i18n.t(`message.${res.data.id}`)
          },
          { root: true }
        );
        errorHandler({});
      })
      .catch(res => {
        dispatch(
          "notificationStore/createErrorNotificationForApiRequest",
          res,
          { root: true }
        );
        errorHandler(res.response.data.errors);
      });
  }
};

const mutations = {
  setProfile(state, { profile }) {
    state.profile = profile;
  },
  updateProfile(state, { profile }) {
    state.profile = { ...state.profile, ...profile };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
